import { QRCodeSVG } from 'qrcode.react';
import { theme } from '../../../theme';

type QRCodePreviewProps = {
  venueSlug: string;
  size?: number;
  includeLabel?: boolean;
  venueName?: string;
};

const getAppUrl = (): string => {
  return import.meta.env.VITE_FRONTEND_URL || window.location.origin;
};

export const QRCodePreview = ({
  venueSlug,
  size = 200,
  includeLabel = false,
  venueName,
}: QRCodePreviewProps) => {
  const qrUrl = `${getAppUrl()}/qr/${venueSlug}`;

  return (
    <div className="inline-flex flex-col items-center">
      <div
        className="bg-white rounded-lg p-3"
        style={{ border: '3px solid #20c997' }}
      >
        <QRCodeSVG
          value={qrUrl}
          size={size}
          level="M"
          includeMargin={false}
          bgColor="#ffffff"
          fgColor="#0a1929"
        />
      </div>
      {includeLabel && venueName && (
        <p className={`mt-2 text-sm font-medium ${theme.text.heading} text-center`}>
          {venueName}
        </p>
      )}
    </div>
  );
};

// Export URL builder for use in template service
export const buildQRUrl = (venueSlug: string): string => {
  return `${getAppUrl()}/qr/${venueSlug}`;
};
